
const CreateIco =() => {
    return (
        <svg
            width="15"
            height="16"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 9.27964V13.4977C15 13.9451 14.8244 14.3743 14.5118 14.6907C14.1993 15.0071 13.7754 15.1849 13.3333 15.1849H1.66667C1.22464 15.1849 0.800716 15.0071 0.488155 14.6907C0.175595 14.3743 0 13.9451 0 13.4977V1.68721C0 1.23973 0.175595 0.810584 0.488155 0.494171C0.800716 0.177759 1.22464 0 1.66667 0H5.83333V1.68721H1.66667V13.4977H13.3333V9.27964H15Z"
                fill="#3A3EA0"
            />
            <path
                d="M14.9999 3.37441H11.6665V0H9.99987V3.37441H6.66653V5.06162H9.99987V8.43603H11.6665V5.06162H14.9999V3.37441Z"
                fill="#3A3EA0"
            />
        </svg>
    );
}

export default CreateIco;
